import React from "react";
import Footer from "./Footer/Footer";
import Header from "./Header/Header";

function Feedback() {
  return (
    <>
      <Header />
      <div className="header-container">
        <h3 className="feed"> Feedback and Enquiry Form </h3>
      </div>
      <div className="header-container">
        <h6>Please choose the relevant feedback form</h6>
      </div>
      <div className="feedback-container">
        <div className="rectangle">
          <a
            href="http://www.nparks.gov.sg/feedback"
            className="form-selectplant__each"
          >
            Plant Health Diagnostics Services
          </a>
        </div>
        <div className="rectangle">
          <a
            href="
https://www.nparks.gov.sg/avs/feedback"
            className="form-select__each"
          >
            CAVS Laboratory Services
          </a>
        </div>
      </div>
      <div className="header-container">
        <h6>
          <a
            href="https://www.oneservice.sg.
 "
          >
            submit via the OneService Mobile App
          </a>
        </h6>
        {/* <div className="header-container">
          Enquiries and feedback on dog licensing and animal-related matters:
          1800 476 1600 (24-hours)
        </div> */}
      </div>
      <Footer />
    </>
  );
}

export default Feedback;
